module.exports = __webpack_public_path__ + "static/img/sharebg.9f380a1e.png";